module.exports = __webpack_public_path__ + "static/60gde-d1b48d0893abbbc9757ca7f7f9d62d94.gif";